import React, { useReducer, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
// contexts
import AuthContext from "./contexts/auth";
// reducers
import authReducer, { login } from './reducers/auth';
import draftReducer, {} from './reducers/draft';
// utils and others
import { getAuthenticated } from './utils/localStorage';
import PrivateRoute from './PrivateRoute';

import AdminLayout from "./layouts/Admin";
import PersonnelLayout from "./layouts/Personnel";
import AuditorLayout from "./layouts/Auditor";
import ClerkLayout from "./layouts/Clerk";
import UserLayout from "./layouts/User";

import Home from "./views/Pages/Home.js";
import SignIn from "./views/Pages/SignIn";
import Dashboard from "./views/Dashboard/Dashboard";
import NotFound from "./views/Pages/NotFound";



function App(props) {
    const [ auth, authDispatch ] = useReducer(authReducer, undefined);
    const [ draft, draftDispatch ] = useReducer(draftReducer, undefined);
    
    useEffect(() => {
        // check if auth exists on localStorage
        const authenticated = getAuthenticated();

        if (authenticated !== undefined && authenticated !== '') {
            // update AuthContext
            // console.log(`initial localStorage check, authenticated exists ${authenticated}`)
            authDispatch(login(authenticated));
        }
        
    }, []);

    return (
        <AuthContext.Provider value={{ 
            auth, 
            authDispatch, 
            draft,
            draftDispatch, 
        }}>
            <Router>
                <Switch>
                    <Route exact path="/" component={Home} />
                    <Route exact path="/home" component={Home} />
                    <Route exact path="/login" 
                        component={SignIn}
                        layout= "/auth"
                    />
                    <PrivateRoute path="/admin" component={AdminLayout} />
                    <PrivateRoute path="/personnel" component={PersonnelLayout} />
                    <PrivateRoute path="/auditor" component={AuditorLayout} />
                    <PrivateRoute path="/clerk" component={ClerkLayout} />
                    <PrivateRoute path="/users" component={UserLayout} />
                    <Route exact={true} component={NotFound} />
                </Switch>
            </Router>
        </AuthContext.Provider>
    );
}

export default App;
